import React from 'react'
import { useSelector } from 'react-redux';
import { calculateCommission } from '../../tab/tabview/netTrade/utils/tradeCalculation';

const Commission = ({ row }) => {
    const { amount, side, openPrice, interest, symbolId } = row;
    const symbol = useSelector(state => state.updateSymbol?.symbols?.[symbolId] || state.watchlist.symbols?.[symbolId]);
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId]);
    const refSymbol = useSelector(state => state.updateSymbol?.symbols?.[symbol?.referenceSymbolId]) || null


    if (!symbol?.bid || !symbol?.ask) return;
    if (!symbolParameterData) return;

    const commission = calculateCommission({ row, symbol, refSymbol, symbolData: symbolParameterData, });
    return <div>{commission == 0 ? '0.00' : `-${Math.abs(commission).toFixed(2)}`}</div>;
}

export default Commission